
const ja = {
  // Navigation
  "nav.about": "ABOUT",
  "nav.services": "SERVICES",
  "nav.company": "COMPANY",
  "nav.contact": "CONTACT",
  
  // About Page
  "about.hero.title": "ABOUT",
  "about.hero.subtitle": "私たちについて",
  "about.mission.label": "Mission",
  "about.mission.text": "Providing creators and athletes with the platform to grow, thrive, and monetize.",
  "about.mission.title1": "CreatorやAthletesに",
  "about.mission.title2": "\"収益化できる仕組み\"と",
  "about.mission.title3": "\"持続可能な成長できる環境\"を。",
  "about.service.soccer.title": "サッカー留学・育成事業",
  "about.service.soccer.name": "Global Soccer Dreams",
  "about.service.soccer.desc": "世界基準のサッカー育成 × メンタリング、キャリアアドバイス",
  "about.service.creator.title": "クリエイターECプラットフォーム",
  "about.service.creator.name": "Mira Closet",
  "about.service.creator.desc": "\"好き\"から始まる、ショッピング。",
  "about.vision.title": "新たな価値を、世界へ。",
  "about.vision.text": "私たちは、サッカー留学・育成事業「Global Soccer Dreams」と、クリエイターECプラットフォーム「Mira Closet」を通じて、アスリートとクリエイターの才能を最大限に引き出し、持続可能な成長を実現するための2つの事業を展開しています。",
  "about.services.title": "提供サービス",
  "about.services.subtitle": "Our Services",
  "about.services.sports": "SPORTS",
  "about.services.soccer.title": "サッカー育成× 留学 × キャリア支援",
  "about.services.soccer.item1": "アメリカサッカー留学サポート",
  "about.services.soccer.item2": "個別トレーニングプログラム",
  "about.services.soccer.item3": "オンライン指導・メンタリング",
  "about.services.creatorec": "CREATOR EC",
  "about.services.creator.title": "クリエイター主導型ショッピングプラットフォーム",
  "about.services.creator.text": "「好きな人の、好きなものを買う、好きなブランドを知る、好きなファッションを知る」信頼ベースのEC体験。",
  "about.contact.title": "Global Soccer DreamsやMira Closetについて詳しく知りたい方はこちら",
  "about.contact.text": "ご質問・ご相談は、お問い合わせフォームからお気軽にご連絡ください。専門スタッフが対応いたします。",
  "about.contact.button": "お問い合わせフォームへ",

  // Services Page
  "services.hero.title": "SERVICES",
  "services.hero.subtitle": "提供サービス",
  "services.soccer.tag": "SOCCER PROGRAM",
  "services.soccer.title": "Global Soccer Dreams",
  "services.soccer.subtitle": "世界基準のサッカー育成 × 留学 × キャリア支援",
  "services.soccer.content.title": "提供内容",
  "services.soccer.content.item1": "アメリカサッカー留学サポート",
  "services.soccer.content.item2": "個別トレーニングプログラム",
  "services.soccer.content.item3": "オンライン指導・メンタリング",
  "services.soccer.target.title": "対象",
  "services.soccer.target.text": "アメリカで挑戦したいアスリート",
  "services.mira.tag": "CREATOR PLATFORM",
  "services.mira.title": "Mira Closet",
  "services.mira.subtitle": "クリエイター主導型ショッピングプラットフォーム",
  "services.mira.content.title": "提供内容",
  "services.mira.content.item1": "クリエイター専用ショップ",
  "services.mira.content.item2": "クリエイターレコメンド",
  "services.mira.content.item3": "アフィリエイト",
  "services.mira.feature.title": "特徴",
  "services.mira.feature.text": "「好きな人の、好きなものを買う、好きなブランドを知る、好きなファッションを知る」信頼ベースのEC体験。",
  "services.comparison.soccer.item1": "アメリカ留学サポート",
  "services.comparison.soccer.item2": "個別メンタリング",
  "services.comparison.soccer.item3": "キャリア構築支援",
  "services.comparison.soccer.item4": "コミュニティ",
  "services.comparison.mira.item1": "専用ショップ開設",
  "services.comparison.mira.item2": "レコメンド機能",
  "services.comparison.mira.item3": "アフィリエイト",

  // Company Page
  "company.hero.title": "COMPANY",
  "company.hero.subtitle": "会社概要",
  "company.info.name.label": "会社名",
  "company.info.name.value": "Global Soccer Dreams Inc",
  "company.info.ceo.label": "代表",
  "company.info.ceo.value": "Tessho Kobayashi",
  "company.info.business.label": "事業内容",
  "company.info.business.value1": "スポーツ留学・育成",
  "company.info.business.value2": "クリエイターEC",
  "company.info.address.label": "本社所在地",
  "company.info.address.value": "東京都渋谷区渋谷2-19-15 宮益坂ビルディング609",
  "company.services.title": "事業紹介",
  "company.services.soccer.title": "Global Soccer Dreams",
  "company.services.soccer.subtitle": "世界基準のサッカー育成 × 留学 × キャリア支援",
  "company.services.soccer.item1": "海外サッカー留学サポート",
  "company.services.soccer.item2": "個別トレーニングプログラム",
  "company.services.soccer.item3": "オンライン指導・メンタリング",
  "company.services.mira.title": "Mira Closet",
  "company.services.mira.subtitle": "クリエイター主導型ショッピングプラットフォーム",
  "company.services.mira.item1": "クリエイター専用ショップ",
  "company.services.mira.item2": "クリエイターレコメンド＆アフィリエイト",
  "company.vision.title": "Our Vision",
  "company.vision.text": "私たちは、アスリートやクリエイターが持つ才能を最大限に引き出し、グローバルな舞台で活躍できる環境を提供します。一人ひとりの夢を実現するために、最高のサポートを届けます。",

  // Contact Page
  "contact.hero.title": "Contact",
  "contact.hero.subtitle": "お問い合わせ",
  "contact.form.category.title": "お問い合わせ内容を選択してください",
  "contact.form.category.soccer": "Global Soccer Dreams",
  "contact.form.category.mira": "Mira Closet",
  "contact.form.category.other": "その他",
  "contact.form.name.label": "お名前",
  "contact.form.name.placeholder": "山田 太郎",
  "contact.form.email.label": "メールアドレス",
  "contact.form.email.placeholder": "example@email.com",
  "contact.form.company.label": "会社名（任意）",
  "contact.form.company.placeholder": "株式会社〇〇",
  "contact.form.message.label": "お問い合わせ内容",
  "contact.form.message.placeholder": "お問い合わせ内容をご記入ください（500文字以内）",
  "contact.form.message.note": "※500文字以内でご入力ください",
  "contact.form.submit": "送信する",
  "contact.form.submitting": "送信中...",
  "contact.form.success": "お問い合わせありがとうございます。送信が完了しました。",
  "contact.form.error": "送信に失敗しました。もう一度お試しください。",

  // Footer
  "footer.tagline": "個人の才能を、グローバルな価値へ。",
  "footer.services": "SERVICES",
  "footer.company": "COMPANY",
  "footer.about": "About",
  "footer.companyInfo": "Company Info",
  "footer.privacy": "Privacy Policy",
  "footer.contact": "Contact",
  "footer.copyright": "© 2025 Global Soccer Dreams Inc. All rights reserved.",

  // Language
  "lang.ja": "日本語",
  "lang.en": "English"
};

export default ja;
